import { Component, OnDestroy } from '@angular/core';
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';
import { EnvironmentListService } from '@modules/common/services/environment-list.service';
import { merge, Subscription } from 'rxjs';

@Component({
    selector: 'app-nav-env-message',
    templateUrl: './nav-env-message.component.html',
    styleUrls: ['./nav-env-message.component.scss']
})
export class NavEnvMessageComponent implements OnDestroy {
    public environmentMessage?: string;

    private readonly _subscription: Subscription;

    constructor(
        private _environmentListService: EnvironmentListService,
        private _currentEnvironmentService: CurrentEnvironmentService
    ) {
        this._subscription = merge(this._environmentListService.environmentListChanged, this._currentEnvironmentService.environmentChanged)
            .subscribe(() => this.updateEnvironmentMessage());
    }

    public ngOnDestroy(): void {
        this._subscription.unsubscribe();
    }

    private updateEnvironmentMessage(): void {
        this.environmentMessage = undefined;
        const environmentName = this._currentEnvironmentService.getCurrentEnvironmentName();
        if (environmentName) {
            const environment = this._environmentListService.getEnvironmentList().filter(x => x.name.toLowerCase() == environmentName.toLowerCase())[0];

            if (environment && !environment.isDefault) {
                this.environmentMessage = environment.description;
            }
        }
    }
}